webpackJsonp([16],{

/***/ 2723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _utils = __webpack_require__(762);

var _signup_email = __webpack_require__(2724);

var _signup_email2 = _interopRequireDefault(_signup_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var isLicensed = license && license.IsLicensed === 'true';
    var enableSignUpWithEmail = config.EnableSignUpWithEmail === 'true';
    var siteName = config.SiteName;
    var termsOfServiceLink = config.TermsOfServiceLink;
    var privacyPolicyLink = config.PrivacyPolicyLink;
    var customBrand = license.CustomBrand === 'true';
    var enableCustomBrand = config.EnableCustomBrand === 'true';
    var customDescriptionText = config.CustomDescriptionText;

    return {
        isLicensed: isLicensed,
        enableSignUpWithEmail: enableSignUpWithEmail,
        siteName: siteName,
        termsOfServiceLink: termsOfServiceLink,
        privacyPolicyLink: privacyPolicyLink,
        customBrand: customBrand,
        enableCustomBrand: enableCustomBrand,
        customDescriptionText: customDescriptionText,
        passwordConfig: (0, _utils.getPasswordConfig)(license, config)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_signup_email2.default);

/***/ }),

/***/ 2724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_actions = __webpack_require__(832);

var _user_actions = __webpack_require__(781);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _browser_history = __webpack_require__(273);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _site_name_and_description = __webpack_require__(941);

var _site_name_and_description2 = _interopRequireDefault(_site_name_and_description);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SignupEmail = function (_React$Component) {
    (0, _inherits3.default)(SignupEmail, _React$Component);
    (0, _createClass3.default)(SignupEmail, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                location: _propTypes2.default.object,
                isLicensed: _propTypes2.default.bool.isRequired,
                enableSignUpWithEmail: _propTypes2.default.bool.isRequired,
                siteName: _propTypes2.default.string,
                termsOfServiceLink: _propTypes2.default.string,
                privacyPolicyLink: _propTypes2.default.string,
                customBrand: _propTypes2.default.bool.isRequired,
                enableCustomBrand: _propTypes2.default.bool.isRequired,
                customDescriptionText: _propTypes2.default.string,
                passwordConfig: _propTypes2.default.object
            };
        }
    }]);

    function SignupEmail(props) {
        (0, _classCallCheck3.default)(this, SignupEmail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignupEmail.__proto__ || (0, _getPrototypeOf2.default)(SignupEmail)).call(this, props));

        _this.handleSubmit = _this.handleSubmit.bind(_this);

        _this.getInviteInfo = _this.getInviteInfo.bind(_this);
        _this.renderEmailSignup = _this.renderEmailSignup.bind(_this);
        _this.isUserValid = _this.isUserValid.bind(_this);

        _this.state = _this.getInviteInfo();
        return _this;
    }

    (0, _createClass3.default)(SignupEmail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _diagnostics_actions.trackEvent)('signup', 'signup_user_01_welcome');
        }
    }, {
        key: 'getInviteInfo',
        value: function getInviteInfo() {
            var _this2 = this;

            var data = new URLSearchParams(this.props.location.search).get('d');
            var hash = new URLSearchParams(this.props.location.search).get('h');
            var inviteId = new URLSearchParams(this.props.location.search).get('id');
            var email = '';
            var teamDisplayName = '';
            var teamName = '';
            var teamId = '';
            var loading = false;
            var serverError = '';
            var noOpenServerError = false;

            if (hash && hash.length > 0) {
                var parsedData = JSON.parse(data);
                email = parsedData.email;
                teamDisplayName = parsedData.display_name;
                teamName = parsedData.name;
                teamId = parsedData.id;
            } else if (inviteId && inviteId.length > 0) {
                loading = true;
                (0, _team_actions.getInviteInfo)(inviteId, function (inviteData) {
                    if (!inviteData) {
                        _this2.setState({ loading: false });
                        return;
                    }

                    _this2.setState({
                        loading: false,
                        serverError: '',
                        teamDisplayName: inviteData.display_name,
                        teamName: inviteData.name,
                        teamId: inviteData.id
                    });
                }, function () {
                    _this2.setState({
                        loading: false,
                        noOpenServerError: true,
                        serverError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'signup_user_completed.invalid_invite',
                            defaultMessage: 'The invite link was invalid.  Please speak with your Administrator to receive an invitation.'
                        })
                    });
                });

                data = null;
                hash = null;
            }

            return {
                data: data,
                hash: hash,
                email: email,
                teamDisplayName: teamDisplayName,
                teamName: teamName,
                teamId: teamId,
                inviteId: inviteId,
                loading: loading,
                serverError: serverError,
                noOpenServerError: noOpenServerError
            };
        }
    }, {
        key: 'handleSignupSuccess',
        value: function handleSignupSuccess(user, data) {
            var _this3 = this;

            (0, _diagnostics_actions.trackEvent)('signup', 'signup_user_02_complete');
            (0, _user_actions.loginById)(data.id, user.password, '', function () {
                if (_this3.state.hash > 0) {
                    _browser_store2.default.setGlobalItem(_this3.state.hash, (0, _stringify2.default)({ usedBefore: true }));
                }

                (0, _user_actions.loadMe)().then(function () {
                    var redirectTo = new URLSearchParams(_this3.props.location.search).get('redirect_to');
                    if (redirectTo) {
                        _browser_history.browserHistory.push(redirectTo);
                    } else {
                        GlobalActions.redirectUserToDefaultTeam();
                    }
                });
            }, function (err) {
                if (err.id === 'api.user.login.not_verified.app_error') {
                    _browser_history.browserHistory.push('/should_verify_email?email=' + encodeURIComponent(user.email) + '&teamname=' + encodeURIComponent(_this3.state.teamName));
                } else {
                    _this3.setState({
                        serverError: err.message,
                        isSubmitting: false
                    });
                }
            });
        }
    }, {
        key: 'isUserValid',
        value: function isUserValid() {
            var providedEmail = this.refs.email.value.trim();
            if (!providedEmail) {
                this.setState({
                    nameError: '',
                    emailError: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup_user_completed.required' }),
                    passwordError: '',
                    serverError: ''
                });
                return false;
            }

            if (!Utils.isEmail(providedEmail)) {
                this.setState({
                    nameError: '',
                    emailError: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup_user_completed.validEmail' }),
                    passwordError: '',
                    serverError: ''
                });
                return false;
            }

            var providedUsername = this.refs.name.value.trim().toLowerCase();
            if (!providedUsername) {
                this.setState({
                    nameError: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup_user_completed.required' }),
                    emailError: '',
                    passwordError: '',
                    serverError: ''
                });
                return false;
            }

            var usernameError = Utils.isValidUsername(providedUsername);
            if (usernameError === 'Cannot use a reserved word as a username.') {
                this.setState({
                    nameError: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'signup_user_completed.reserved' }),
                    emailError: '',
                    passwordError: '',
                    serverError: ''
                });
                return false;
            } else if (usernameError) {
                this.setState({
                    nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'signup_user_completed.usernameLength',
                        values: {
                            min: _constants2.default.MIN_USERNAME_LENGTH,
                            max: _constants2.default.MAX_USERNAME_LENGTH
                        }
                    }),
                    emailError: '',
                    passwordError: '',
                    serverError: ''
                });
                return false;
            }

            var providedPassword = this.refs.password.value;
            var pwdError = Utils.isValidPassword(providedPassword, this.props.passwordConfig);
            if (pwdError) {
                this.setState({
                    nameError: '',
                    emailError: '',
                    passwordError: pwdError,
                    serverError: ''
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var _this4 = this;

            e.preventDefault();

            // bail out if a submission is already in progress
            if (this.state.isSubmitting) {
                return;
            }

            if (this.isUserValid()) {
                this.setState({
                    nameError: '',
                    emailError: '',
                    passwordError: '',
                    serverError: '',
                    isSubmitting: true
                });

                var user = {
                    email: this.refs.email.value.trim(),
                    username: this.refs.name.value.trim().toLowerCase(),
                    password: this.refs.password.value,
                    allow_marketing: true
                };

                (0, _user_actions.createUserWithInvite)(user, this.state.data, this.state.hash, this.state.inviteId, this.handleSignupSuccess.bind(this, user), function (err) {
                    _this4.setState({
                        serverError: err.message,
                        isSubmitting: false
                    });
                });
            }
        }
    }, {
        key: 'renderEmailSignup',
        value: function renderEmailSignup() {
            var emailError = null;
            var emailHelpText = _react2.default.createElement(
                'span',
                { className: 'help-block' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'signup_user_completed.emailHelp',
                    defaultMessage: 'Valid email required for sign-up'
                })
            );
            var emailDivStyle = 'form-group';
            if (this.state.emailError) {
                emailError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.emailError
                );
                emailHelpText = '';
                emailDivStyle += ' has-error';
            }

            var nameError = null;
            var nameHelpText = _react2.default.createElement(
                'span',
                { className: 'help-block' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'signup_user_completed.userHelp',
                    defaultMessage: 'Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols \'.\', \'-\' and \'_\'',
                    values: {
                        min: _constants2.default.MIN_USERNAME_LENGTH,
                        max: _constants2.default.MAX_USERNAME_LENGTH
                    }
                })
            );
            var nameDivStyle = 'form-group';
            if (this.state.nameError) {
                nameError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.nameError
                );
                nameHelpText = '';
                nameDivStyle += ' has-error';
            }

            var passwordError = null;
            var passwordDivStyle = 'form-group';
            if (this.state.passwordError) {
                passwordError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.passwordError
                );
                passwordDivStyle += ' has-error';
            }

            var yourEmailIs = null;
            if (this.state.email) {
                yourEmailIs = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'signup_user_completed.emailIs',
                    defaultMessage: 'Your email address is <strong>{email}</strong>. You\'ll use this address to sign in to {siteName}.',
                    values: {
                        email: this.state.email,
                        siteName: this.props.siteName
                    }
                });
            }

            var emailContainerStyle = 'margin--extra';
            if (this.state.email) {
                emailContainerStyle = 'hidden';
            }

            return _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'inner__content' },
                    _react2.default.createElement(
                        'div',
                        { className: emailContainerStyle },
                        _react2.default.createElement(
                            'h5',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.whatis',
                                    defaultMessage: 'What\'s your email address?'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: emailDivStyle },
                            _react2.default.createElement('input', {
                                id: 'email',
                                type: 'email',
                                ref: 'email',
                                className: 'form-control',
                                defaultValue: this.state.email,
                                placeholder: '',
                                maxLength: '128',
                                autoFocus: true,
                                spellCheck: 'false',
                                autoCapitalize: 'off'
                            }),
                            emailError,
                            emailHelpText
                        )
                    ),
                    yourEmailIs,
                    _react2.default.createElement(
                        'div',
                        { className: 'margin--extra' },
                        _react2.default.createElement(
                            'h5',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.chooseUser',
                                    defaultMessage: 'Choose your username'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: nameDivStyle },
                            _react2.default.createElement('input', {
                                id: 'name',
                                type: 'text',
                                ref: 'name',
                                className: 'form-control',
                                placeholder: '',
                                maxLength: _constants2.default.MAX_USERNAME_LENGTH,
                                spellCheck: 'false',
                                autoCapitalize: 'off'
                            }),
                            nameError,
                            nameHelpText
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'margin--extra' },
                        _react2.default.createElement(
                            'h5',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.choosePwd',
                                    defaultMessage: 'Choose your password'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: passwordDivStyle },
                            _react2.default.createElement('input', {
                                id: 'password',
                                type: 'password',
                                ref: 'password',
                                className: 'form-control',
                                placeholder: '',
                                maxLength: '128',
                                spellCheck: 'false'
                            }),
                            passwordError
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'margin--extra' },
                        _react2.default.createElement(
                            'button',
                            {
                                id: 'createAccountButton',
                                type: 'submit',
                                onClick: this.handleSubmit,
                                className: 'btn-primary btn',
                                disabled: this.state.isSubmitting
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup_user_completed.create',
                                defaultMessage: 'Create Account'
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                customDescriptionText = _props.customDescriptionText,
                enableSignUpWithEmail = _props.enableSignUpWithEmail,
                isLicensed = _props.isLicensed,
                location = _props.location,
                privacyPolicyLink = _props.privacyPolicyLink,
                siteName = _props.siteName,
                termsOfServiceLink = _props.termsOfServiceLink;


            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            if (this.state.loading) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            var emailSignup = void 0;
            if (enableSignUpWithEmail) {
                emailSignup = this.renderEmailSignup();
            } else {
                return null;
            }

            var terms = null;
            if (!this.state.noOpenServerError && emailSignup) {
                terms = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'create_team.agreement',
                        defaultMessage: 'By proceeding to create your account and use {siteName}, you agree to our <a href=\'{TermsOfServiceLink}\'>Terms of Service</a> and <a href=\'{PrivacyPolicyLink}\'>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.',
                        values: {
                            siteName: siteName,
                            TermsOfServiceLink: termsOfServiceLink,
                            PrivacyPolicyLink: privacyPolicyLink
                        }
                    })
                );
            }

            if (this.state.noOpenServerError) {
                emailSignup = null;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_back_button2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container padding--less' },
                        _react2.default.createElement('img', {
                            className: 'signup-team-logo',
                            src: _logo2.default
                        }),
                        _react2.default.createElement(_site_name_and_description2.default, {
                            customDescriptionText: customDescriptionText,
                            isLicensed: isLicensed,
                            siteName: siteName
                        }),
                        _react2.default.createElement(
                            'h4',
                            { className: 'color--light' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup_user_completed.lets',
                                defaultMessage: 'Let\'s create your account'
                            })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'color--light' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup_user_completed.haveAccount',
                                defaultMessage: 'Already have an account?'
                            }),
                            ' ',
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    to: '/login' + location.search
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.signIn',
                                    defaultMessage: 'Click here to sign in.'
                                })
                            )
                        ),
                        emailSignup,
                        serverError,
                        terms
                    )
                )
            );
        }
    }]);
    return SignupEmail;
}(_react2.default.Component);

exports.default = SignupEmail;

/***/ })

});


// WEBPACK FOOTER //
// 16.312776e7e313b18e080e.js